import React from "react";
import $ from "jquery";

const ErrorPopup = () => {
  return (
    <>
      <div className="error_popupbg">
        <div className="error_pos" style={{ width: "60%" }}>
          {/* <h3>Error</h3> */}
          <img
            src="/assets/images/cross.svg"
            className="error_cros"
            alt=""
            onClick={() => {
              $(".error_popupbg").hide();
            }}
          />
          <p className="textp" style={{ marginTop: "13px" }}>
            There is some error.
          </p>
        </div>
      </div>
    </>
  );
};

export default ErrorPopup;
